import { render, staticRenderFns } from "./gameintro.vue?vue&type=template&id=43b41de8&scoped=true"
import script from "./gameintro.vue?vue&type=script&lang=js"
export * from "./gameintro.vue?vue&type=script&lang=js"
import style0 from "./gameintro.vue?vue&type=style&index=0&id=43b41de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b41de8",
  null
  
)

export default component.exports